export default {
  core: {
    100: '#004445'
  },
  dark: {
    100: '#1F2228'
  },
  light: {
    100: '#fff'
  },
  accent: {
    100: '#9BA4B8',
    90: '#E1E4ED',
    80: '#F6F7FA',
    70: '#EDF7FF'
  }
}
